import { useRecoilValue } from 'recoil';
import { streamingCurrentStateState } from '../../storage/streaming';
import FloatingStreamingWindow from '../currentState/streaming/shared/FloatingStreamingWindow';
import { GptAttendEventForm } from '../gpt/GptAttendEventForm';
import { GptEventDetail } from '../gpt/GptEventDetail';
import { useGptAttendEvent } from '../gpt/hooks/useGptAttendEvent';
import { FloatingCardsLayout } from '../layout/FloatingCardsLayout';

export function GptEventPage() {
  const { isAttending: attendingEvent } = useGptAttendEvent();
  const streamingCurrentState = useRecoilValue(streamingCurrentStateState);
  const isStreaming = !!streamingCurrentState;

  return (
    <>
      <FloatingCardsLayout
        listSize={700}
        list={<GptEventDetail />}
        contentSize={400}
        content={attendingEvent && <GptAttendEventForm />}
      />
      {isStreaming && <FloatingStreamingWindow />}
    </>
  );
}
